import { createSlice } from "@reduxjs/toolkit";

export const encryptedNotesSlice = createSlice({
  name: "encryptedNotes",
  initialState: {
    isLocked: true,
    decryptedData: null,
    exists: false,
    loading: false,
    error: null,
  },
  reducers: {
    setExists: (state, action) => {
      state.exists = action.payload;
    },
    setDecryptedData: (state, action) => {
      state.decryptedData = action.payload;
      state.isLocked = false;
      state.error = null;
    },
    setLocked: (state, action) => {
      state.isLocked = action.payload;
      if (action.payload) {
        state.decryptedData = null;
      }
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearData: (state) => {
      state.isLocked = true;
      state.decryptedData = null;
      state.exists = false;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setExists,
  setDecryptedData,
  setLocked,
  setLoading,
  setError,
  clearData,
} = encryptedNotesSlice.actions;

export default encryptedNotesSlice.reducer;
